import React from 'react';
import * as styles from './FloatingPanel.module.css';

interface FloatingPanelWrapperProps {
  children: React.ReactNode;
}

export const FloatingPanelWrapper: React.FC<FloatingPanelWrapperProps> = ({ children }) => {
  return <div className={styles['panel-wrapper']}>{children}</div>;
};
